import styles from "./button.module.css"

const Button = (props) => {
    return(
        <a href={props.href} data-video-src={props.videoAlertPath} className={`${props.type === "main" ? styles.main : props.type === "colorful" ? styles.colorful : styles.normal} ${props.className} ${styles.button}`}>{props.children}</a>
    )
}

export default Button